import React from 'react'

import {
  Icon,
  Button,
  DeleteOutlined,
  Edit,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string, number } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

import LikeDislikeButton from './Components/LikeDislikeButton/LikeDislikeButton'

function TopActions({
  canDelete,
  canEdit,
  canUseLikeFeature,
  isEditing,
  isUpdating = false,
  useCaseId,
  likeCount,
  isLiked,
  itemId,
  isLoading = false,
  onDelete,
  onEdit,
  onSave,
  onCancel,
  onLike,
  onUnlike,
  canSave = false,
}) {
  const { t, tv } = useUseCaseTranslate()

  return (
    <div
      className="use-case-media-card__top-actions"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="use-case-media-card__top-actions-left">
        {canDelete && (
          <Button
            aria-label={tv('viewer.delete')}
            customClass="use-case-media-card__action-button"
            icon={<Icon svgComponent={DeleteOutlined} color="dark" />}
            onClick={(e) => {
              e.stopPropagation()
              onDelete(useCaseId)
            }}
            type="secondary"
            size="small"
            variant="only-icon"
          />
        )}
        {!isEditing && canEdit && (
          <Button
            aria-label={tv('viewer.edit')}
            customClass="use-case-media-card__action-button"
            icon={<Icon svgComponent={Edit} color="dark" />}
            onClick={onEdit}
            type="secondary"
            size="small"
            variant="only-icon"
          />
        )}
        {isEditing && (
          <>
            <Button
              aria-label={t('viewer.saveChanges')}
              onClick={onSave}
              type="secondary"
              size="small"
              customClass="use-case-media-card__action-button"
              disabled={!canSave || isUpdating}
            >
              {t('viewer.save')}
            </Button>
            <Button
              aria-label={t('viewer.cancelEditing')}
              onClick={onCancel}
              type="secondary"
              size="small"
              customClass="use-case-media-card__action-button"
              disabled={isUpdating}
            >
              {t('viewer.cancel')}
            </Button>
          </>
        )}
      </div>
      {canUseLikeFeature && (
        <LikeDislikeButton
          useCaseId={useCaseId}
          likeCount={likeCount}
          isLiked={isLiked}
          itemId={itemId}
          onLike={onLike}
          onUnlike={onUnlike}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}

TopActions.propTypes = {
  canDelete: bool.isRequired,
  canEdit: bool.isRequired,
  canUseLikeFeature: bool.isRequired,
  isEditing: bool.isRequired,
  isUpdating: bool,
  useCaseId: string.isRequired,
  likeCount: number.isRequired,
  isLiked: bool.isRequired,
  itemId: number.isRequired,
  isLoading: bool,
  onDelete: func.isRequired,
  onEdit: func.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  onLike: func.isRequired,
  onUnlike: func.isRequired,
  canSave: bool,
}

export default TopActions
